import type { ISession } from '../interface/session';

let memoryCache: Array<ISession> = [];

const get = (name: string) => memoryCache.filter(session => session.name === name)[0];

const save = (session: ISession) => {
    /* only add if it's missing */
    if (!get(session.name)) {
        memoryCache.push(session);
    } else {
        console.error(
            `Already exists, ignoring add to cache for session: ${JSON.stringify(session)}`,
        );
    }
};

const remove = (sessionDelete: ISession) => {
    memoryCache = memoryCache.filter(session => session.name !== sessionDelete.name);
};

const all = () => memoryCache;

const module = {
    get,
    save,
    remove,
    all,
};

export default module;
